import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl, teamHasLink, teamNameLabel, getFootballTeamImagePath } from '../../common/rcs_gaz_mc_core_FE';
import TeamLabel from '../TeamLabel';
import Timing from '../TimeResults/Timing';
import Result from '../TimeResults/Result';
import IconFont from '../../components/shared/IconFont';
import MatchRowScorers from '../../components/MatchRowScorers';
import MatchRowIcon from '../../components/MatchRowIcon';
import { MatchRowWrapper, MatchStatsWrapper, BetWrapper, MatchLinkWrapper, MatchForfait } from './styles';
import ConfigManager from '../../common/configManager/configManager';
import BetBar from '../BetBar';
import { disableLinktoMatch } from '../../utils/linkManagement';

const MatchRow = ({
  matchRow, dictionary, isMobile, isHighlight, isDeskFav, competitionId, hasHighlights, betMatch, betType, seasonLink, loadEveryAdv,
}) => {
  const isWalkover = matchRow && matchRow.get('status') === 'WALKOVER';
  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isLive = () => matchRow.get('status') === 'LIVE';

  const classLink = () => {
    const homeCode = matchRow.getIn(['homeTeam', 'teamCode']);
    const awayCode = matchRow.getIn(['awayTeam', 'teamCode']);
    const teamCodeToExclude = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'D1', 'D2', 'E1', 'E2', 'F1', 'F2', 'G1', 'G2', 'H1', 'H2', 'VO1', 'VO2', 'VO3', 'VO4', 'VO5', 'VO6', 'VO7', 'VO8', 'VO', 'VQ1', 'VQ2', 'VQ3', 'VQ4', 'PS1', 'PS2', 'VS1', 'VS2'];
    let returnedClass = '';
    if (homeCode && awayCode) {
      if ((homeCode.length < 3 && awayCode.length < 3) || teamCodeToExclude.includes(homeCode) || teamCodeToExclude.includes(homeCode)) {
        returnedClass = 'no-event';
      }
    }
    //Eliminata che rompe i link per le partite U21
    // if (homeCode && awayCode && Number(homeCode[homeCode.length - 1]) && Number(awayCode[awayCode.length - 1])) {
    //   returnedClass = 'no-event';
    // }
    if (!teamHasLink(matchRow.getIn(['homeTeam', 'teamName'])) || !teamHasLink(matchRow.getIn(['awayTeam', 'teamName']))) {
      returnedClass = 'no-event';
    }
    if (disableLinktoMatch(window.matchcenterPage.sportId, window.matchcenterPage.competitionId)) {
      returnedClass = 'no-event';
    }
    return returnedClass;
  };
  const imagesURL = ConfigManager.getFootballTeams('min');
  const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

  const getTeamsName = () => {
    const teamsName = {};
    teamsName.homeTeamId = matchRow.getIn(['homeTeam', 'teamId']);
    teamsName.homeTeam = matchRow.getIn(['homeTeam', 'teamName']);
    teamsName.awayTeamId = matchRow.getIn(['awayTeam', 'teamId']);
    teamsName.awayTeam = matchRow.getIn(['awayTeam', 'teamName']);
    return teamsName;
  };

  const getRoundTripLoser = () => {
    const competitionRoundId = matchRow.get('competitionRoundId');
    const competitionIdAsString = competitionId.toString();
    const isSpecialCup =
        competitionIdAsString === '5' ||
        competitionIdAsString === '6' ||
        (competitionRoundId === 'Semi-Finals' && competitionIdAsString === '259') ||
        competitionIdAsString === '1125';
    if (matchRow.get('firstLegResult') && isSpecialCup) {
      const winnerId =
        matchRow.get('secondLegResult') && matchRow.getIn(['secondLegResult', 'winnerId']);
      const loser =
          winnerId === getTeamsName().homeTeamId ? 'away' : 'home';
      return winnerId ? loser : null;
    } else {
      return null;
    }
  };

  return (
    <MatchRowWrapper isHighlight={isHighlight} >
      <MatchLinkWrapper
        isHighlight={isHighlight}
        className={classLink()}
        href={window.matchcenterPage.sportId !== '5'
          ? prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), 1, competitionId, process.env.REACT_APP_SITE, false, seasonLink)
        : '#'}
      >
        <Row style={{
          width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
        }}
        >
          <Col md={3.3} offset={{ md: 0.4, sm: 0.4, xs: 0.4 }} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={teamNameLabel(matchRow.getIn(['homeTeam', 'teamName']))}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('homeTeam'))}
              marginLeft={0.5}
              width="28px;"
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'home'}
            />
          </Col>
          <Col md={3.3} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={teamNameLabel(matchRow.getIn(['awayTeam', 'teamName']))}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('awayTeam'))}
              marginLeft={0.5}
              width="28px;"
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'away'}
            />
          </Col>
          <Col md={2} sm={2} xs={2} style={{ paddingRight: 0, paddingLeft: '15px' }}>
            <Timing
              isMobile={isMobile}
              timing={matchRow.get('timing')}
              resultType={matchRow.get('resultType')}
              date={matchRow.get('utcDate')}
              isLive={isLive()}
              dictionary={dictionary.competitionTable}
            />
          </Col>
          <Col lg={2} md={1.5} sm={1.5} xs={1.5} style={{ paddingLeft: 0, paddingRight: '15px' }}>
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              awayPenRes={awayResPen}
              homePenRes={homeResPen}
              status={matchRow.get('status')}
              isMobile={isMobile}
            />
          </Col>
          <Col
            lg={1}
            md={1.8}
            sm={1.8}
            xs={1.5}
            style={{
              display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: '10px', paddingLeft: '15px',
            }}
          >
            {(matchRow.get('status') || isDeskFav) &&
              <IconFont
                className="icon-matchcenter-right-arrow"
                color="linkColor"
                font={18}
                weight="bold"
                withCursor
              />
            }
          </Col>
        </Row>
        {window.matchcenterPage.sportId !== '5' && matchRow && (
          matchRow.getIn(['homeTeam', 'starData', 'goals']).size > 0 ||
          matchRow.getIn(['starData', 'substitutions']) > 0 ||
          matchRow.getIn(['starData', 'yellowBookings']) > 0 ||
          matchRow.getIn(['starData', 'redBookings']) > 0
          || matchRow.getIn(['awayTeam', 'starData', 'goals']).size > 0 ||
          matchRow.get('status') === 'WALKOVER'
        ) &&
          <Row
            className="isAnHighlights"
            style={{
            width: '100%',
            marginRight: '0',
            marginLeft: '0',
            alignItems: 'initial',
            display: !hasHighlights ? 'none' : 'flex',
            }}
          >
            <Col md={3.30} sm={3.30} xs={3.30} offset={{ md: 0.45, sm: 0.45, xs: 0.45 }} style={{ paddingRight: '0px', paddingLeft: '34px' }}>
              {matchRow && matchRow.get('status') !== 'WALKOVER' &&
              <MatchRowScorers
                color="gray"
                weight="normal"
                size={0.8}
                scorers={matchRow.getIn(['homeTeam', 'starData', 'goals'])}
                font="narrowRegular"
              />}
              {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['homeTeam', 'starData', 'shootOuts']) && matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties']) &&
              <MatchRowScorers
                color="gray"
                weight="normal"
                size={1.5}
                penaltyScorers={matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties'])}
                font="narrowRegular"
              />
              }
            </Col>
            <Col md={3.30} sm={3.30} xs={3.30} style={{ paddingRight: '0px', paddingLeft: '34px' }}>
              {matchRow && matchRow.get('status') !== 'WALKOVER' &&
              <MatchRowScorers
                color="gray"
                weight="normal"
                size={0.8}
                scorers={matchRow.getIn(['awayTeam', 'starData', 'goals'])}
                font="narrowRegular"
              />
              }
              {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['awayTeam', 'starData', 'shootOuts']) && matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties']) &&
              <MatchRowScorers
                color="gray"
                weight="normal"
                size={1.5}
                penaltyScorers={matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties'])}
                font="narrowRegular"
              />
              }
            </Col>
            <Col xl={3.6} lg={3.4} md={3} sm={3} xs={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline' }} offset={{ md: 0.95, sm: 0.95, xs: 0.95 }}>
              <MatchStatsWrapper>
                {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'substitutions']) > 0 &&
                  <MatchRowIcon
                    matchStats={matchRow.getIn(['starData', 'substitutions'])}
                    color="black"
                    bg="green"
                    size={12}
                    className="icon-matchcenter-arrows-circle"
                    marginRight={0.2}
                    font="narrowMedium"
                    isSubstitution
                  />
                }
                {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'redBookings']) > 0 &&
                  <MatchRowIcon
                    matchStats={matchRow.getIn(['starData', 'redBookings'])}
                    color="white"
                    bg="red"
                    size={12}
                    className="icon-matchcenter-rectangle"
                    font="narrowMedium"
                  />
                }
                {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'yellowBookings']) > 0 &&
                  <MatchRowIcon
                    matchStats={matchRow.getIn(['starData', 'yellowBookings'])}
                    color="black"
                    bg="yellow"
                    size={12}
                    className="icon-matchcenter-rectangle"
                    font="narrowMedium"
                  />
                }
                {matchRow.get('status') === 'WALKOVER' &&
                  <MatchForfait>
                    {`${dictionary.competitionTable.timing.Walkover}`}
                  </MatchForfait>
                }
              </MatchStatsWrapper>
            </Col>
          </Row>
        }
      </MatchLinkWrapper>
      {/* {matchRow.get('status') !== 'FULL' && betMatch && betMatch.odds && betType !== 0 && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
          <BetBar
            isMobile={isMobile}
            betType={betType}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
          }
        </BetWrapper>
        }*/}
      {betMatch && betMatch.odds && loadEveryAdv &&
        <BetWrapper>
          <BetBar
            isMobile={isMobile}
            betType={betType}
            betData={betMatch.odds}
            competitionId={window.matchcenterPage.competitionId}
          />
        </BetWrapper>
      }
      {!loadEveryAdv && matchRow.status !== 'FULL' && betMatch && betMatch.odds && betType !== 0 && betType !== '4' && process.env.REACT_APP_SITE !== 'corriere' &&
      <BetWrapper>
        {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
        <BetBar
          isMobile={isMobile}
          betType={betType}
          betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
          competitionId={window.matchcenterPage.competitionId}
        />
              }
      </BetWrapper>
      }
      {loadEveryAdv && matchRow.status === 'PREMATCH' && betMatch && betMatch.odds && betType !== 0 && betType === '4' && process.env.REACT_APP_SITE !== 'corriere' &&
      <BetWrapper>
        {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
        <BetBar
          isMobile={isMobile}
          betType={betType}
          betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
          competitionId={window.matchcenterPage.competitionId}
        />
              }
      </BetWrapper>
      }
    </MatchRowWrapper>
  );
};

MatchRow.propTypes = {
  matchRow: PropTypes.any,
  //actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  //date: PropTypes.string,
  //sportId: PropTypes.any,
  isHighlight: PropTypes.bool,
  isDeskFav: PropTypes.bool,
  competitionId: PropTypes.any,
  hasHighlights: PropTypes.bool,
  betMatch: PropTypes.any,
  betType: PropTypes.any,
  seasonLink: PropTypes.any,
  loadEveryAdv: PropTypes.any,
};

export default MatchRow;



// WEBPACK FOOTER //
// ./src/components/MatchRow/index.js